import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { modalCreate } from 'actions/modals'
import ButtonIcon from 'components/ButtonIcon'
import { IconClose } from 'icons'
import { Column, Container } from 'components/Grid'
import styles from './Modal.scss'

class Modal extends Component {
  static propTypes = {
    alloWBGClose: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    className: PropTypes.string,
    disable: PropTypes.bool,
    dispatch: PropTypes.func,
    forceClose: PropTypes.bool,
    id: PropTypes.string,
    iconClassName: PropTypes.string,
    modals: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  }

  static defaultProps = {
    alloWBGClose: false,
    disable: false,
    forceClose: false,
    show: false,
  }

  componentWillMount() {
    if (this.props.dispatch && this.props.id) {
      this.props.dispatch(modalCreate(this.props.id))
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forceClose) {
      this._close()
    }
  }

  _close = () => {
    this.props.onClose()
  }

  _bgClose = () => {
    if (this.props.alloWBGClose) { this._close() }
  }

  /* handleOnBoarding = () => {
    this.props.dispatch(onBoardingStart(this.props.onBoardingKey, true))
  } */

  render() {
    const {
      children, className, disable, id, iconClassName, modals, show,
    } = this.props

    const showModal = modals && modals[id] && (modals[id].show || show)
    const showing = modals && (modals._isShowing || show)
    const displayModal = (showModal) ? styles.isOpen : ''

    // Document class adjust
    if (showModal) {
      document.body.classList.add(styles.modalIsOpen)
    } else if (!showing) {
      document.body.classList.remove(styles.modalIsOpen)
    }

    const buttonIconClasses = classnames(styles.logo, styles.close, iconClassName)

    return (
      <div onClick={this._bgClose}>
        { showModal &&
        <div className={classnames(styles.modal, displayModal, className)}>
          <Container>
            <Column base={12} className={styles.content} push={3} >
              {children}
            </Column>
            { !disable &&
              <ButtonIcon
                className={buttonIconClasses}
                label="Close window"
                onClick={this._close}
              >
                <IconClose height="26" width="26" />
              </ButtonIcon>
              }
          </Container>
        </div>
        }
      </div>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js